import config from "../../config";

const AI_MAINFRAME_HOST = config.aiMainframeHost || "";

export function getHost() {
  if (!AI_MAINFRAME_HOST) {
    throw new Error("AI_MAINFRAME_HOST is not set");
  }
  return AI_MAINFRAME_HOST;
}

class ApiError extends Error {
  constructor(message, status) {
    super(message);
    this.status = status;
  }
}

async function handleResponse(response) {
  if (!response.ok) {
    throw new ApiError(
      `HTTP error! status: ${response.status}`,
      response.status
    );
  }
  return response.json();
}

function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

function jsonHeaders(token) {
  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
}

export async function fetchSessions(token, apiBasePath) {
  const response = await fetch(
    `${AI_MAINFRAME_HOST}${apiBasePath}/sessions?limit=50`,
    { headers: authHeaders(token) }
  );
  return handleResponse(response);
}

export async function fetchSession(token, apiBasePath, sessionId) {
  const response = await fetch(
    `${AI_MAINFRAME_HOST}${apiBasePath}/sessions/${sessionId}`,
    { headers: authHeaders(token) }
  );
  return handleResponse(response);
}

export async function createSession(token, apiBasePath, { partnerId } = {}) {
  const body = partnerId ? { partner_id: partnerId } : {};
  const response = await fetch(`${AI_MAINFRAME_HOST}${apiBasePath}/sessions`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(body)
  });
  return handleResponse(response);
}

export async function deleteSession(token, apiBasePath, sessionId) {
  const response = await fetch(
    `${AI_MAINFRAME_HOST}${apiBasePath}/sessions/${sessionId}`,
    {
      method: "DELETE",
      headers: authHeaders(token)
    }
  );
  if (!response.ok) {
    throw new ApiError(
      `Failed to delete session: ${response.status}`,
      response.status
    );
  }
}

export async function getFeedback(token, contentType, contentId, userId) {
  const params = new URLSearchParams({
    content_type: contentType,
    content_id: contentId,
    user_id: userId
  });
  const response = await fetch(
    `${AI_MAINFRAME_HOST}/api/feedback?${params}`,
    { headers: authHeaders(token) }
  );
  return handleResponse(response);
}

export async function submitFeedback(token, body) {
  const response = await fetch(`${AI_MAINFRAME_HOST}/api/feedback`, {
    method: "POST",
    headers: jsonHeaders(token),
    body: JSON.stringify(body)
  });
  return handleResponse(response);
}


// No AbortSignal parameter: aborting the fetch would cancel backend agent
// processing mid-run. Client-side guards (streaming refs, mounted checks)
// handle cleanup instead.
export async function sendMessage(token, apiBasePath, sessionId, message) {
  const response = await fetch(
    `${AI_MAINFRAME_HOST}${apiBasePath}/sessions/${sessionId}/messages`,
    {
      method: "POST",
      headers: jsonHeaders(token),
      body: JSON.stringify({ message })
    }
  );
  if (!response.ok) {
    throw new ApiError(
      `HTTP error! status: ${response.status}`,
      response.status
    );
  }
  return response;
}
